angular.module('eStories.player.model', [])
    .service('PlayerModel', [
        'WS',
        'LL',
        'FindawayPlayer',
        'FilePerChapterPlayer',
        'MultiChapterFilePlayer',
        '$rootScope',
        'LibraryModel',
        '$timeout',
        function (WS,
                  LL,
                  FindawayPlayer,
                  FilePerChapterPlayer,
                  MultiChapterFilePlayer,
                  $rootScope,
                  LibraryModel,
                  $timeout) {

            var model = this;

            model.playerShrunken = true;

            model.toggleShrinkPlayer = function () {
                model.playerShrunken = !model.playerShrunken;
            };

            function toSeconds(time) {
                return Math.floor(time / 1000);
            }

            model.isSample = function () {
                if (!model.currentPlayingLibraryAudiobook) {
                    return;
                }
                return model.getPlayerProvider(model.currentPlayingLibraryAudiobook.audiobook).isSample;
            };

            model.isFindawayFormat = function () {
                return model.currentPlayingLibraryAudiobook.audiobook.chapterFileFormat === 'FINDAWAY';
            };

            model.isFpcFormat = function () {
                return model.currentPlayingLibraryAudiobook.audiobook.chapterFileFormat === 'FILE_PER_CHAPTER';
            };

            model.isMcpFormat = function () {
                return model.currentPlayingLibraryAudiobook.audiobook.chapterFileFormat === 'MULTI_CHAPTER_FILE';
            };

            model.eventCallbacksObj = {};

            model.eventCallbacksObj.handleLoadError = function (error) {
                console.error('load error: ' + error);
            };

            model.eventCallbacksObj.handlePaused = function () {
                model.isPlaying = false;
            };

            model.eventCallbacksObj.handleTimeChanged = function (currentTime, isSample) {

                var second = toSeconds(currentTime);

                if (second % 1 == 0 && currentTime && model.reportedProgressToLibrary != second) {
                    model.currentPlayingLibraryAudiobook.currentTime = toSeconds(model.getCurrentPositionInChapter()).toString().toShortHHMMSS();
                    model.reportedProgressToLibrary = second;
                    model.audiobookSlider.value = second;

                    if (!isSample) {
                        model.currentPlayingLibraryAudiobook.progress.position = Math.floor(currentTime);
                        model.setAudiobookRemainingTime();
                        model.setAudiobookProgress(model.currentPlayingLibraryAudiobook);
                    }
                }

                //Save Progress Interval
                if (second % 10 === 0 && model.reportedTime !== second && !isSample) {
                    if (model.currentPlayingLibraryAudiobook.progress.chapter.id != null) {
                        model.reportedTime = second;
                        const saveProgressObj = {
                            position: Math.floor(currentTime),
                            reportTime: new Date().getTime(),
                            libraryAudiobookId: model.currentPlayingLibraryAudiobook.id,
                            chapterId: model.currentPlayingLibraryAudiobook.progress.chapter.id
                        };
                        LibraryModel.saveAudiobookProgress(saveProgressObj);
                    }
                }
                safeDigest($rootScope);
            };

            model.eventCallbacksObj.handleTrackChanged = function (track) {
                model.reportedTime = 0;
                model.reportedProgressToLibrary = 0;
                model.currentPlayingLibraryAudiobook.currentTime = "0".toShortHHMMSS();
                model.currentPlayingLibraryAudiobook.progress.chapter = model.currentPlayingLibraryAudiobook.audiobook.chapterList[track];
                model.audiobookSlider.options.ceil = toSeconds(model.currentPlayingLibraryAudiobook.progress.chapter.duration);
                safeDigest($rootScope);
            };

            model.eventCallbacksObj.handleOnLoad = function (playerObj) {
                if (model.isMcpFormat()) {
                    model.audiobookSlider.options.ceil = toSeconds(model.currentPlayingLibraryAudiobook.progress.chapter.duration);
                } else {
                    model.audiobookSlider.options.ceil = toSeconds(playerObj.duration * 1000);
                }
            };

            model.eventCallbacksObj.handleOnEnd = function () {
                if (model.isFpcFormat() && model.checkIfMoreTracksAreAvailable().hasMoreTracks) {
                    model.skipToTrack(model.checkIfMoreTracksAreAvailable().nextTrackObj.chapterObj);
                } else {
                    model.isPlaying = false;
                    safeDigest($rootScope);
                }
            };

            model.checkIfMoreTracksAreAvailable = function () {

                const libraryAudiobook = model.currentPlayingLibraryAudiobook;

                if (!libraryAudiobook.audiobook.chapterList) {
                    return {hasMoreTracks: false};
                }

                const trackObj = model.getCurrentChapterObj(libraryAudiobook.audiobook.chapterList,
                    libraryAudiobook.progress.chapter.id);

                const hasExtraTracks = trackObj.index + 1 <= libraryAudiobook.audiobook.chapterList.length;

                if (!hasExtraTracks) {
                    //There are NO more tracks to play, it reached the end of the chapterList
                    return {hasMoreTracks: false};
                }
                //There are more tracks available to play
                const chapterObj = libraryAudiobook.audiobook.chapterList[trackObj.index + 1];
                const trackObjToPlay = model.getCurrentChapterObj(libraryAudiobook.audiobook.chapterList,
                    chapterObj.id);

                return {
                    hasMoreTracks: true,
                    nextTrackObj: trackObjToPlay
                };
            };

            // Play Audiobook or Sample
            model.play = function (libraryAudiobook, isSample) {
                model.firstTimePlay = false;
                if (model.isPlaying) {
                    model.pausePlaying();
                }
                if (isSample) {
                    model.currentPlayingLibraryAudiobook = {
                        audiobook: libraryAudiobook
                    };
                    model.getPlayerProvider(model.currentPlayingLibraryAudiobook.audiobook).play(model.currentPlayingLibraryAudiobook.audiobook, isSample);
                } else {

                    FindawayPlayer.player.trigger('unload');

                    var trackObj = model.getCurrentChapterObj(libraryAudiobook.audiobook.chapterList,
                        libraryAudiobook.progress.chapter.id);
                    var positionToPLay = libraryAudiobook.progress.position;

                    model.tagPlayLlEvent(libraryAudiobook);
                    //Save this book on server for future play
                    model._setCurrentlyPlayingAudiobook(libraryAudiobook.id);
                    //Set this libraryAudibook to this service currentPLayingLibraryAudiobook Object
                    model._setLibraryAudiobookToPlay(libraryAudiobook);
                    //Recalculate all progress on book just in case not on the 'Library Page'
                    model.setAudiobookProgress(libraryAudiobook);
                    //Play actual Audiobook
                    model.getPlayerProvider(libraryAudiobook.audiobook).play(libraryAudiobook, null, trackObj, positionToPLay);
                }
                model.isPlaying = true;
            };

            // Player Controllers
            model.resumePlaying = function () {
                model.isPlaying = true;
                if (model.firstTimePlay) {
                    model.play(model.currentPlayingLibraryAudiobook);
                } else {
                    model.getPlayerProvider(model.currentPlayingLibraryAudiobook.audiobook).resumePlay(model.currentPlayingLibraryAudiobook.audiobook);
                }
            };

            model.pausePlaying = function (libraryAudiobook, isSample) {
                model.isPlaying = false;
                if (isSample) {
                    model.currentPlayingLibraryAudiobook = {
                        audiobook: libraryAudiobook
                    };
                    model.getPlayerProvider(model.currentPlayingLibraryAudiobook.audiobook).pause();
                } else {
                    model.getPlayerProvider(model.currentPlayingLibraryAudiobook.audiobook).pause();
                }
            };

            model.seekJump = function (forward) {
                const libraryAudiobook = model.currentPlayingLibraryAudiobook;
                if (model.seekJumpTime === 'CH') {
                    let currentChapterIndex = model.getCurrentChapterObj(libraryAudiobook.audiobook.chapterList,
                        libraryAudiobook.progress.chapter.id).index;

                    let chapterIndexToSkip;
                    if (forward) {
                        chapterIndexToSkip = currentChapterIndex + 1 >= libraryAudiobook.audiobook.chapterList.length
                            ? 0
                            : currentChapterIndex + 1;
                    } else {
                        chapterIndexToSkip = currentChapterIndex - 1 < 0
                            ? currentChapterIndex
                            : currentChapterIndex - 1;
                    }

                    model.audiobookSlider.value = 0;
                    const chapterObj = libraryAudiobook.audiobook.chapterList[chapterIndexToSkip];
                    const trackObjToPlay = model.getCurrentChapterObj(libraryAudiobook.audiobook.chapterList,
                        chapterObj.id);
                    safeDigest($rootScope);
                    model.skipToTrack(trackObjToPlay.chapterObj);

                } else {
                    model.seekJumpTime = model.seekJumpTime || 30;
                    libraryAudiobook.progress.position = forward ?
                        libraryAudiobook.progress.position + model.seekJumpTime * 1000 :
                        libraryAudiobook.progress.position - model.seekJumpTime * 1000;
                    model.getPlayerProvider(libraryAudiobook.audiobook).seekTo(libraryAudiobook.progress.position);
                }
            };

            model.skipToTrack = function (chapterObj) {
                model.isPlaying = true;
                const libraryAudiobook = model.currentPlayingLibraryAudiobook;
                const trackObjToPlay = model.getCurrentChapterObj(libraryAudiobook.audiobook.chapterList,
                    chapterObj.id);

                let callbackFunc = null;

                if (model.isFpcFormat() || model.isMcpFormat()) {
                    //This callbackFunc updates handleTrackChanged when manually changing tracks for Fpc format
                    callbackFunc = function () {
                        model.eventCallbacksObj.handleTrackChanged(trackObjToPlay.index)
                    };
                }

                model.getPlayerProvider(libraryAudiobook.audiobook).skipToTrack(libraryAudiobook, trackObjToPlay, callbackFunc);
            };

            model.setSeekJumpType = function (type) {
                model.seekJumpTime = type;
            };

            model.setSeekJumpType(30);

            // Initial setup of Library Audiobook;
            model._setLibraryAudiobookToPlay = function (libraryAudiobook) {
                model.currentPlayingLibraryAudiobook = libraryAudiobook;
                model.currentPlayingLibraryAudiobook.totalRuntime =
                    model.getAudiobookTotalRuntime(libraryAudiobook.audiobook.chapterList);
            };

            model.setAudiobookProgress = function (libraryAudiobook) {
                if (libraryAudiobook.audiobook.chapterList.length === 0) {
                    return;
                }

                if (!libraryAudiobook.progress) {
                    libraryAudiobook.progress = {
                        chapter: {
                            id: libraryAudiobook.audiobook.chapterList[0].id,
                            chapterNumber: libraryAudiobook.audiobook.chapterList[0].chapterNumber,
                            duration: libraryAudiobook.audiobook.chapterList[0].duration
                        },
                        position: 0
                    };
                }

                libraryAudiobook.totalRuntime = model.getAudiobookTotalRuntime(libraryAudiobook.audiobook.chapterList);
                libraryAudiobook.positionInBook = model.getPositionInBookByChapter(libraryAudiobook.audiobook.chapterList,
                    libraryAudiobook.progress.chapter,
                    libraryAudiobook.progress.position);
                let currentTimeStr =
                    toSeconds(Math.max(0, libraryAudiobook.progress.position)).toString().toShortHHMMSS();
                libraryAudiobook.currentTime = currentTimeStr;
                libraryAudiobook.remainingTime = libraryAudiobook.totalRuntime - model.getPositionInBookByChapter(libraryAudiobook.audiobook.chapterList,
                    libraryAudiobook.progress.chapter, libraryAudiobook.progress.position);
                libraryAudiobook.progressPercent = (libraryAudiobook.positionInBook / libraryAudiobook.totalRuntime) * 100;
            };

            model.getAudiobookTotalProgress = function (libraryAudiobook) {
                if (!model.currentPlayingLibraryAudiobook && !libraryAudiobook) {
                    return toSeconds(0).toString().toHHMMSS();
                }
                if (model.currentPlayingLibraryAudiobook && libraryAudiobook.id === model.currentPlayingLibraryAudiobook.id) {
                    return toSeconds(model.currentPlayingLibraryAudiobook.positionInBook).toString().toHHMMSS();
                }
                return toSeconds(libraryAudiobook.positionInBook).toString().toHHMMSS();
            };

            model.getAudiobookRemainingTime = function (libraryAudiobook) {
                if (!model.currentPlayingLibraryAudiobook && !libraryAudiobook) {
                    return toSeconds(0).toString().toHHMMSS();
                }
                if (model.currentPlayingLibraryAudiobook && libraryAudiobook.id === model.currentPlayingLibraryAudiobook.id) {
                    return toSeconds(model.currentPlayingLibraryAudiobook.remainingTime).toString().toHHMMSS();
                }
                return toSeconds(libraryAudiobook.remainingTime).toString().toHHMMSS();
            };

            model.setAudiobookRemainingTime = function () {
                if (model.currentPlayingLibraryAudiobook.totalRuntime) {
                    model.currentPlayingLibraryAudiobook.remainingTime = model.currentPlayingLibraryAudiobook.totalRuntime -
                        model.getPositionInBookByChapter(model.currentPlayingLibraryAudiobook.audiobook.chapterList,
                            model.currentPlayingLibraryAudiobook.progress.chapter, model.currentPlayingLibraryAudiobook.progress.position);
                } else {
                    model.currentPlayingLibraryAudiobook.remainingTime = 0;
                }
            };

            model._initPlayerModel = function () {
                FindawayPlayer.initFindawayProvider(model.eventCallbacksObj);
                FilePerChapterPlayer.initPlayer(model.eventCallbacksObj);
                MultiChapterFilePlayer.initPlayer(model.eventCallbacksObj);
            };

            model.getPlayerProvider = function (audiobook, isSample) {
                if (audiobook.providerType === "FINDAWAY" || isSample) {
                    return FindawayPlayer;
                } else {
                    switch (audiobook.chapterFileFormat) {
                        case 'FILE_PER_CHAPTER':
                            return FilePerChapterPlayer;
                        case 'MULTI_CHAPTER_FILE':
                            return MultiChapterFilePlayer;
                    }
                }
            };

            model.getCurrentPositionInChapter = function () {
                if (!model.currentPlayingLibraryAudiobook) {
                    return;
                }
                return model.getPlayerProvider(model.currentPlayingLibraryAudiobook.audiobook).getCurrentTime();
            };

            model.getTotalBookmarkCount = function () {
                if (model.currentPlayingLibraryAudiobook == null || FindawayPlayer.isSample) {
                    return;
                }
                return model.currentPlayingLibraryAudiobook.bookmarkList.length;
            };

            model._setCurrentlyPlayingAudiobook = function (libraryAudiobookId) {
                const requestObj = {
                    playDate: new Date().getTime(),
                    libraryAudiobookId: libraryAudiobookId
                };
                return WS.callServer('library/setCurrentlyPlayingAudiobook', requestObj);
            };

            model.doesAudiobookHaveParts = function (audiobook) {
                if (!audiobook || !audiobook.chapterList || !audiobook.chapterList.length) {
                    return false;
                }

                var previousPart = null;
                for (var i = 0; i < audiobook.chapterList.length; i++) {
                    var chapter = audiobook.chapterList[i];
                    if (previousPart == null) {
                        previousPart = chapter.partNumber;
                    }

                    if (previousPart !== chapter.partNumber) {
                        return true;
                    }
                }

                return false;
            };

            model.firstTimePlay = true;

            model._getCurrentlyPlayingAudiobook = async function () {
                const response = await WS.callServer('library/getCurrentlyPlayingAudiobook', {});
                if (response.responseStatus === 'SUCCESS') {
                    if (response.libraryAudiobook) {
                        model.currentPlayingLibraryAudiobook = response.libraryAudiobook;
                        if (!response.libraryAudiobook.progress) {
                            model.currentPlayingLibraryAudiobook.progress = {
                                chapter: {
                                    id: response.libraryAudiobook.audiobook.chapterList[0].id,
                                    chapterNumber: response.libraryAudiobook.audiobook.chapterList[0].chapterNumber,
                                    duration: response.libraryAudiobook.audiobook.chapterList[0].duration
                                },
                                position: 0
                            };
                        }

                        model.setAudiobookProgress(response.libraryAudiobook);
                        model._setLibraryAudiobookToPlay(response.libraryAudiobook);
                        model.setAudiobookRemainingTime();

                        $timeout(function () {
                            model.audiobookSlider.value = toSeconds(model.currentPlayingLibraryAudiobook.progress.position);
                            if (model.currentPlayingLibraryAudiobook.progress.chapter) {
                                model.audiobookSlider.options.ceil = toSeconds(model.currentPlayingLibraryAudiobook.progress.chapter.duration);
                            }
                            safeDigest($rootScope);
                        }, 0)
                    }
                }
            };

            model.audiobookSlider = {
                value: 0,
                options: {
                    ceil: 0,
                    showSelectionBar: true,
                    hidePointerLabels: true,
                    hideLimitLabels: true,
                    getSelectionBarColor: function () {
                        return "#ffc20e";
                    },
                    getPointerColor: function () {
                        return "#157aa1";
                    },
                    onChange: function () {
                        model.currentPlayingLibraryAudiobook.currentTime = model.audiobookSlider.value.toString().toShortHHMMSS();
                        model.getPlayerProvider(model.currentPlayingLibraryAudiobook.audiobook).seekTo(Math.floor(model.audiobookSlider.value * 1000));
                    }
                }
            };

            model.volumeSlider = {
                value: 50,
                options: {
                    ceil: 100,
                    floor: 0,
                    showSelectionBar: true,
                    hidePointerLabels: true,
                    hideLimitLabels: true,
                    vertical: true,
                    getSelectionBarColor: function () {
                        return "#dadfe1";
                    },

                    getPointerColor: function () {
                        return "#07678b";
                    },

                    onChange: function () {
                        model.getPlayerProvider(model.currentPlayingLibraryAudiobook.audiobook).setVolume(model.volumeSlider.value, model.isSample());
                    }
                }
            };


            model.mutePlayer = function () {
                model.getPlayerProvider(model.currentPlayingLibraryAudiobook.audiobook).mutePlayer();
                model.volumeSlider.value = 0;
            };

            model.getCurrentChapterObj = function (chapterList, currentChapterId) {
                for (var i = 0; i < chapterList.length; i++) {
                    if (chapterList[i].id === currentChapterId) {
                        return {chapterObj: chapterList[i], index: i};
                    }
                }
            };

            model.getChapterCount = function () {
                if (!model.currentPlayingLibraryAudiobook || model.isSample()) {
                    return;
                }

                const audiobook = model.currentPlayingLibraryAudiobook.audiobook;
                return audiobook.chapterList.filter(a => a.chapterNumber).reduce(acc => acc + 1, 0);
            };

            model.getNumberOfChaptersInPart = function (currentChapter) {
                const currentlyPlayingAudiobook = model.currentPlayingLibraryAudiobook;
                if (!currentlyPlayingAudiobook || model.isSample()) {
                    return;
                }
                return currentlyPlayingAudiobook.audiobook.chapterList
                    .filter(v => v.partNumber === currentChapter.partNumber)
                    .reduce(acc => acc + 1, 0);
            };


            model.getAudiobookTotalRuntime = function (chapterList) {
                return chapterList.reduce((acc, val) => {
                    acc += val.duration;
                    return acc
                }, 0);
            };

            model.getPositionInBookByChapter = function (allChapters, currentChapter, currentChapterPosition) {
                if (!currentChapter) {
                    return 0;
                }

                let result = 0;
                for (let i = 0; i < allChapters.length; i++) {
                    let audiobookChapter = allChapters[i];
                    if (audiobookChapter.id === currentChapter.id) {
                        result += currentChapterPosition;
                        return result;
                    } else {
                        result += audiobookChapter.duration;
                    }
                }
                return result;
            };

            model.getChapterDuration = function () {
                if (!model.currentPlayingLibraryAudiobook) {
                    return (0).toString().toShortHHMMSS();
                }

                let duration = null;
                if (model.isSample()) {
                    duration = model.audiobookSlider.options.ceil;
                } else {
                    if (model.currentPlayingLibraryAudiobook.progress.chapter) {
                        duration = toSeconds(model.currentPlayingLibraryAudiobook.progress.chapter.duration);
                    }
                }
                if (duration) {
                    return isNaN(duration) ? (0).toString().toShortHHMMSS() : duration.toString().toShortHHMMSS();
                }
            };

            model.getAudiobookProgressBarPercent = function (libraryAudiobook) {
                libraryAudiobook.progressPercent = (libraryAudiobook.positionInBook / libraryAudiobook.totalRuntime) * 100;
                if (libraryAudiobook.progressPercent > 100) {
                    libraryAudiobook.progressPercent = 100;
                }
                if (model.currentPlayingLibraryAudiobook && model.currentPlayingLibraryAudiobook.id === libraryAudiobook.id) {
                    return {width: model.currentPlayingLibraryAudiobook.progressPercent + '%'};
                }
                return {width: libraryAudiobook.progressPercent + '%'};
            };

            model.currentPlayingLibraryAudiobook = null;

            model.tagPlayLlEvent = function (libraryAudiobook) {
                const tagObj = LL.convertAudiobookToLocalyticsObject(libraryAudiobook.audiobook);
                tagObj['Time Listened Buckets'] = model.getProgressTimeBucket(libraryAudiobook.positionInBook);
                tagObj['Time Listened Seconds'] = toSeconds(libraryAudiobook.positionInBook);
                LL.tagEvent('Play', tagObj);
            };

            model.getProgressTimeBucket = function (progressInMs) {
                return Math.ceil((((progressInMs / 1000) / 60) / 15)) * 15;
            };

            model.resetPlayer = function () {
                FindawayPlayer.player ? FindawayPlayer.player.currentTitle = null : "";
                MultiChapterFilePlayer.mcfPlayer.src = null;
                FilePerChapterPlayer.fpcPlayer.src = null;
                model.audiobookSlider.value = 0;
                model.currentPlayingLibraryAudiobook = null;
                model.previousChaptersDuration = null;
                safeDigest($rootScope);
            };

            $rootScope.$on('successfulSignOut', function (event, libraryAudiobook) {
                if (FindawayPlayer.player) {
                    FindawayPlayer.player.trigger('unload');
                }
                model.resetPlayer();
            });

            $rootScope.$on('successfulSignIn', function (event) {
                model._initPlayerModel();
                model._getCurrentlyPlayingAudiobook().then();
            });

            //Initialize Sample Player regadless Logged in or not
            FindawayPlayer.initSamplePlayer(model.eventCallbacksObj);
        }
    ]);
